export const getExamineeName = ({
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
}): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`.trim();
  }

  return 'Examinee';
};

export default getExamineeName;
